import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import { useToastStore } from '@modules/toast/store';

import type {
  IPostbacksAddPayload,
  IPostbacksAddResponse,
} from '../types';
import {
  ADMIN_POSTBACKS_CREATE_URL,
  AFFILIATE_POSTBACKS_CREATE_URL,
  POSTBACKS_CREATE_MUTATION_KEY,
  POSTBACKS_LIST_QUERY_KEY,
  POSTBACKS_PERMISSIONS,
} from '../constants';

export default function usePostbacksCreateMutation(): IContextMutationResult<
  IPostbacksAddResponse,
  Error,
  IPostbacksAddPayload
> {
  const { displayPresetToast } = useToastStore();
  const { fetchPost } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<IPostbacksAddResponse, Error, IPostbacksAddPayload>({
    mutationKey: [POSTBACKS_CREATE_MUTATION_KEY],
    mutationFn: ({ id, type }) => fetchPost<IPostbacksAddResponse>(
      isAdminNamespace.value
        ? ADMIN_POSTBACKS_CREATE_URL
        : AFFILIATE_POSTBACKS_CREATE_URL,
      {
        type,
      },
      {
        permission: POSTBACKS_PERMISSIONS.SHOW,
        urlParams: {
          id,
        },
      },
    ),
    onSuccess({ queryClient }) {
      displayPresetToast('created');
      void queryClient.invalidateQueries({ queryKey: [POSTBACKS_LIST_QUERY_KEY] });
    },
  });
}
